import { UseFormReturn } from 'react-hook-form';
import { ApplicantType, OwnershipDetailsType, ownershipDetailsFormSchema } from '@brighte/validation';
import { StepNavigator } from '@components/StepNavigator';
import { useApplicationData } from '@provider';
import { APPLICATION_STEPS, OWNERSHIP_DETAILS } from '@utils';
import OwnershipDetailFields from './OwnershipDetailFields';
import { useBeforeNextStep, useOwnershipDetailsSummary } from './hooks';

function OwnershipDetails() {
  const { TITLE } = OWNERSHIP_DETAILS;
  const { BusinessDetails: businessDetails, OwnershipDetails: ownershipDetails } = useApplicationData([
    'BusinessDetails',
    'OwnershipDetails',
  ]);
  const { handleBeforeNextStep } = useBeforeNextStep();

  const structure = businessDetails?.enterprise?.structure;

  return (
    <StepNavigator<OwnershipDetailsType>
      schema={ownershipDetailsFormSchema}
      name={APPLICATION_STEPS.OWNERSHIP_DETAILS}
      title={TITLE}
      shouldUnregister={false}
      defaultValues={{
        ...ownershipDetails,
        enterprise: {
          ...ownershipDetails?.enterprise,
          structure,
        },
      }}
      isLoading={false}
      completedContent={useOwnershipDetailsSummary()}
      onBeforeNextStep={handleBeforeNextStep}
    >
      {({ register, ...formProps }: UseFormReturn<OwnershipDetailsType>) => {
        return (
          <>
            <input type="hidden" {...register('enterprise.structure')} name="Structure" value={structure} />
            {structure && <OwnershipDetailFields businessType={structure} {...formProps} />}
            <input type="hidden" {...register('applicant.type')} value={ApplicantType.Primary} />
          </>
        );
      }}
    </StepNavigator>
  );
}

export default OwnershipDetails;
